<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['STATEANDSUBACCOUNT'] }}</legend>
    </div>
    <div class="flex flex-column gap-2">
      <p-select-button [options]="stateOptions"
                       [(ngModel)]="paymentData.status"
                       [allowEmpty]="false"
                       optionLabel="label"
                       optionValue="value"
                       [attr.aria-label]="i18n.i18nLng()['STATE']">
      </p-select-button>
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="account-name">{{ i18n.i18nLng()['SUBACCOUNTNAME'] }}<sup class="sps-sup">*</sup></label>
      <input pInputText
             id="account-name"
             maxlength="80"
             [pAutoFocus]="true"
             [(ngModel)]="paymentData.title"
             [required]="true"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="paymentInvalidFlags.title ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentInvalidFlags.title"
             [attr.aria-describedby]="paymentInvalidFlags.title ? 'title-invalid-help' : null"
             pSize="large"/>
      @if (paymentInvalidFlags.title) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="title-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
      }
    </div>
    @if ((customerGroup === CustomerGroup.SID) && (paymentData.paymentMethod === PaymentMethodName.CREDITCARD)) {
      <div class="flex align-items-center">
        <p-checkbox inputId="chargeback-card" [(ngModel)]="paymentData.isChargebackCard" [binary]="true" size="large"/>
        <label for="chargeback-card" class="ml-2 text-lg">{{ i18n.i18nLng()['CHARGEBACKCARD'] }}</label>
      </div>
    }
  </fieldset>
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['PAYOUTDETAILS'] }}</legend>
    </div>
    <div class="grid w-full">
      <!-- PayPal = PayPal E-Mail Address -->
      @if (paymentData?.paymentMethod === PaymentMethodName.PAYPAL) {
        <div class="col-12 flex flex-column gap-2">
          <label for="paypal-email">{{ i18n.i18nLng()['PAYPALEMAIL'] }}
            @if (paymentData?.active) {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 id="paypal-email"
                 maxlength="255"
                 [(ngModel)]="paymentData.payPalEmailAddress"
                 [required]="false"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.payPalEmailAddress ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.payPalEmailAddress"
                 [attr.aria-describedby]="paymentInvalidFlags?.payPalEmailAddress ? 'email-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags.payPalEmailAddress) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILINFO'] }}</small>
          }
        </div>
      } @else {
        <div class="col-6 flex flex-column gap-2">
          <label for="account-holder">
            {{ i18n.i18nLng()['ACCOUNTHOLDER'] }}
            @if (paymentData.status === 'LIVE') {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 class="w-full"
                 id="account-holder"
                 maxlength="70"
                 [(ngModel)]="paymentData.accountHolder"
                 [required]="paymentData.status === 'LIVE'"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags.accountHolder ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags.accountHolder"
                 [attr.aria-describedby]="paymentInvalidFlags.accountHolder ? 'accountholder-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags.accountHolder) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="accountholder-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
        <div class="col-6 flex flex-column gap-2">
          <label for="IBAN">
            IBAN
            @if (paymentData.status === 'LIVE') {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <!--
          <input class="w-full" pInputText id="IBAN" [(ngModel)]="paymentData.IBAN" [required]="true" [placeholder]="i18n.i18nLng()['PLACEHOLDER']"/>
          -->
          <p-inputmask
              [styleClass]="paymentData.IBAN && paymentData.IBAN.length > 0 ? 'w-full uppercase' : 'w-full'"
              inputId="IBAN"
              ariaLabel="IBAN"
              [(ngModel)]="paymentData.IBAN"
              [autoClear]="false"
              mask="DE99 9999 9999 9999 9999 99"
              slotChar=""
              [required]="paymentData.status === 'LIVE'"
              [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
              [attr.aria-invalid]="showInvalidIBAN"
              [ngClass]="paymentInvalidFlags.IBAN ? 'ng-invalid ng-dirty' : null"
              (onComplete)="checkIBAN()"
              size="large"/>
          @if (showInvalidIBAN || paymentInvalidFlags.IBAN) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="IBAN-invalid-help">{{ i18n.i18nLng()['INVALIDIBANHELP'] }}</small>
          }
        </div>
        <div class="col-6 flex flex-column gap-2">
          <label for="BIC">
            BIC
            @if (paymentData.status === 'LIVE') {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 class="w-full"
                 [ngClass]="paymentInvalidFlags.BIC ? 'ng-invalid ng-dirty' : (paymentData.BIC && paymentData.BIC.length > 0) ? 'uppercase' : null"
                 id="BIC"
                 maxlength="11"
                 [(ngModel)]="paymentData.BIC"
                 [required]="paymentData.status === 'LIVE'"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [attr.aria-invalid]="paymentInvalidFlags.BIC"
                 [attr.aria-describedby]="paymentInvalidFlags.BIC ? 'bic-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags.BIC) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="bic-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
        <div class="col-6 flex flex-column gap-2">
          <label for="bank">
            {{ i18n.i18nLng()['BANK'] }}
            @if (paymentData.status === 'LIVE') {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 class="w-full"
                 id="bank"
                 maxlength="70"
                 [(ngModel)]="paymentData.bank"
                 [required]="paymentData.status === 'LIVE'"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags.bank ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags.bank"
                 [attr.aria-describedby]="paymentInvalidFlags.bank ? 'bank-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags.bank) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="bank-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
      }
    </div>
  </fieldset>
  <fieldset class="sps-fieldset form-data-container">
    <div class="flex flex-column pb-2">
      <legend class="p-dialog-title">{{ i18n.i18nLng()['EMAILNOTIFICATION'] }}</legend>
    </div>
    <div class="flex justify-content-center align-items-center text-lg">
      {{ i18n.i18nLng()['EMAILNOTIFICATIONINFO'] }}
    </div>
    <div class="flex align-items-center">
      <p-checkbox inputId="email-notification" [(ngModel)]="paymentData.emailNotification" [binary]="true" size="large"/>
      <label for="email-notification" class="ml-2 text-lg">{{ i18n.i18nLng()['SENDEMAILPAYMENTNOTIFICATION'] }}</label>
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="email-address">{{ i18n.i18nLng()['EMAILADDRESS'] }}
        @if (paymentData?.emailNotification) {
          <sup class="sps-sup">*</sup>
        }
      </label>
      <input pInputText
             id="email-address"
             [(ngModel)]="paymentData.emailAddress"
             [required]="paymentData?.emailNotification"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="(paymentInvalidFlags.emailAddress || paymentInvalidFlags.invalidEmailFormat) ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentInvalidFlags.emailAddress"
             [attr.aria-describedby]="paymentInvalidFlags.emailAddress ? 'bank-invalid-help' : 'email-address-help'"
             (keydown)="helper.checkIllegalChar($event, ';')"
             maxlength="500"
             pSize="large"/>
      @if (paymentInvalidFlags.emailAddress && paymentData?.emailNotification) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}&nbsp;{{ i18n.i18nLng()['MULTIPLERECIPIENTSHELP'] }}</small>
      } @else {
        @if (paymentInvalidFlags.invalidEmailFormat) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILHELP'] }}</small>
        } @else {
          <small style="line-height: 1.5rem" id="email-address-help">{{ i18n.i18nLng()['MULTIPLERECIPIENTSHELP'] }}</small>
        }
      }
    </div>
  </fieldset>
</div>
